module.exports = {
  publicPath: './',

  configureWebpack: {
    devtool: 'source-map',
  },
  publicPath: process.env.NODE_ENV === 'production' ? './' : './',
  devServer: {
    // proxy: `http://saas.gpinfo.com.cn:8081`,
    proxy: `https://fanccifood.com`,
  },
  lintOnSave: false
}